/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Open_Month_TooltipInputs */



/**
* | output |
* | --- |
* | "Still accruing — recalculated nightly. Actionable after month end." |
*
* @param {Partner_Admin_Commission_Open_Month_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_open_month_tooltip = /** @type {((inputs?: Partner_Admin_Commission_Open_Month_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Open_Month_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Läuft noch auf — wird nächtlich neu berechnet. Nach Monatsende bearbeitbar.")
	return /** @type {LocalizedString} */ ("Still accruing — recalculated nightly. Actionable after month end.")
});